const tooltipCommentFlagIcon = {
  tooltip: 'Questão possui opção de comentário',
  tooltipFileFlag: 'Questão possui opção de arquivo',
};

export default tooltipCommentFlagIcon;
